import { render, staticRenderFns } from "./VoucherForm.vue?vue&type=template&id=422e8607&scoped=true&"
import script from "./VoucherForm.vue?vue&type=script&lang=js&"
export * from "./VoucherForm.vue?vue&type=script&lang=js&"
import style0 from "./VoucherForm.vue?vue&type=style&index=0&id=422e8607&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e8607",
  null
  
)

export default component.exports